import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ScrollDirectiveSharedModule } from '@shared/core/directives/scroll/scroll.directive.shared.module';
import { MaxOnScreenHeightDirectiveSharedModule } from '@shared/core/directives/maxOnScreenHeight';
import { BoxModule } from '@shared/core/components/box';
import { ButtonsModule } from '@shared/core/components/buttons';

import { OrderComponentsModule } from '../components';

import { OrderBoxComponent } from './order-box.shared.component';
import { PickupLabelPipeModule } from '@shared/core/pipes/pickupLabel';
import { InsertVariableToStringModule } from '@shared/core/pipes/insertVariableToString/insert-variable-to-string.pipe.module';
import { LetDirectiveSharedModule } from '@shared/core/directives/let';

@NgModule({
    declarations: [
        OrderBoxComponent
    ],
    imports: [
        CommonModule,
        ScrollDirectiveSharedModule,
        MaxOnScreenHeightDirectiveSharedModule,
        OrderComponentsModule,
        PickupLabelPipeModule,
        BoxModule,
        InsertVariableToStringModule,
        ButtonsModule,
        LetDirectiveSharedModule,
    ],
    exports: [
        OrderBoxComponent
    ],
    providers: [],
})
export class OrderBoxModule { }
